<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="20">
          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
        <Col span="4" class="search-right">
          <Button @click="showAddModal" type="primary">添加</Button>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
    <Modal
      :mask-closable="false"
      v-model="addModal"
      title="添加权限"
      footer-hide
    >
      <forms :resetFlag="resetFlag" @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>
    <Modal
      :mask-closable="false"
      v-model="editModal"
      title="编辑权限"
      footer-hide
    >
      <forms
        :resetFlag="resetFlag"
        :editData="editData"
        @on-ok="editSumit"
        @on-cancel="cancel"
      />
    </Modal>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./form.vue";
import { getRemarkList, addRemark, delRemark, editRemark } from "@/api/data";
export default {
  name: "remark",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        { title: "权限名称", key: "name", editable: true },
        {
          title: "Handle",
          key: "handle",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    // message(type, info) {
    //   if (type === 'success') {
    //     this.$Message.success(info)
    //   } else if (type === 'warning') {
    //     this.$Message.warning(info)
    //   } else if (type === 'error') {
    //     this.$Message.error(info)
    //   } else {
    //     this.$Message.info(info);
    //   }
    // },
    // notice(title, desc) {
    //   this.$Notice.open({
    //     title: title,
    //     desc: desc
    //   });
    // },'
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;
    },
    showEditModal(params) {
      this.editData = params.row;
      this.editModal = true;
    },
    addSumit(formValidate) {
      let data = new FormData();
      data.set("desc", formValidate.desc);
      addRemark(data)
        .then((res) => {
          // res
          // data {code data msg}
          // status
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      let data = new FormData();
      data.set("desc", formValidate.desc);
      editRemark(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      getRemarkList(this.page, this.pageSize).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否确认删除？</p>",
        onOk: () => {
          delRemark(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.tableData.splice(params.index, 1);
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info("已取消");
        },
      });
      // params
      // row
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
